import React, { useMemo } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { recruiterKey } from "../../../helpers/DashboardPipelineHelper";

const SLICE_COLORS = [
  "#0d6efd",
  "#198754",
  "#6f42c1",
  "#fd7e14",
  "#d63384",
  "#20c997",
  "#0dcaf0",
  "#ffc107",
  "#dc3545",
  "#6610f2",
];

export default function ActivePositionsPie({ dashboardCounts }) {
  const rows = Array.isArray(dashboardCounts) ? dashboardCounts : [];

  const data = useMemo(() => {
    const byRecruiter = new Map();
    rows.forEach((user) => {
      const key = recruiterKey(user) || user.user_name || "unknown";
      const name = user.user_name?.trim() || "Unknown";
      const slice = Math.max((user.total_positions || 0) - (user.total_hired || 0), 0);
      const prev = byRecruiter.get(key);
      if (prev) {
        byRecruiter.set(key, { name: prev.name, value: prev.value + slice });
      } else {
        byRecruiter.set(key, { name, value: slice });
      }
    });
    let index = 0;
    return [...byRecruiter.values()]
      .map((item) => ({
        ...item,
        color: SLICE_COLORS[index++ % SLICE_COLORS.length],
      }))
      .filter((item) => item.value > 0);
  }, [rows]);

  return (
    <div className="card shadow-sm">
      <div className="card-body d-flex flex-column" style={{ minHeight: 420 }}>
        <h5 className="mb-3">Active Positions by Recruiter</h5>
        {data.length === 0 ? (
          <p className="text-muted text-center flex-grow-1 d-flex align-items-center justify-content-center mb-0">
            {rows.length === 0
              ? "No dashboard data for this period."
              : "No active positions (demand minus final select) to chart for the current filters."}
          </p>
        ) : (
          <div className="flex-grow-1" style={{ width: "100%", minHeight: 360 }}>
            <ResponsiveContainer width="100%" height={360}>
              <PieChart>
                <Pie
                  data={data}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={120}
                  fill="#8884d8"
                  label
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${entry.name}-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend layout="vertical" verticalAlign="middle" align="right" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
